/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisionSdkTrainingDataListResponse } from '../../models/vision-sdk-training-data-list-response';

export interface VisionSdkTrainingDataGet$Params {
}

export function visionSdkTrainingDataGet(http: HttpClient, rootUrl: string, params?: VisionSdkTrainingDataGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<VisionSdkTrainingDataListResponse>> {
  const rb = new RequestBuilder(rootUrl, visionSdkTrainingDataGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<VisionSdkTrainingDataListResponse>;
    })
  );
}

visionSdkTrainingDataGet.PATH = '/VisionSdk/TrainingData';
